import { api } from "./config";

export async function GetParcelMonitoringSummary() {
  try {
    const response = await api().get("/parcel-monitoring/summary");
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function GetParcelAlertStatusCounts(filters = {}) {
  try {
    const { station, ruleType, severity, search } = filters;
    const response = await api().get("/parcel-monitoring/alerts/counts", {
      params: { station, ruleType, severity, search },
    });
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function GetParcelAlerts(page, pageSize, sort, search, filters = {}) {
  try {
    const { station, ruleType, status, severity } = filters;
    const response = await api().get("/parcel-monitoring/alerts", {
      params: { page, pageSize, sort: JSON.stringify(sort), search, station, ruleType, status, severity },
    });
    if (response.status === 200 && response.data.success) {
      return { status: 200, data: response.data.data, total: response.data.total };
    }
    return { status: response.status, data: [], total: 0, message: response.data?.message };
  } catch (error) {
    return { status: 500, data: [], total: 0, message: error.response?.data?.message || "Network error" };
  }
}

export async function UpdateParcelAlert(id, payload) {
  try {
    const response = await api().patch(`/parcel-monitoring/alerts/${id}`, payload);
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function GetParcelMonitoringSettings() {
  try {
    const response = await api().get("/parcel-monitoring/settings");
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function UpdateParcelMonitoringSettings(payload) {
  try {
    const response = await api().patch("/parcel-monitoring/settings", payload);
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function RunParcelMonitoringSweep() {
  try {
    const response = await api().post("/parcel-monitoring/run");
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function SendParcelMonitoringTestDigest(instanceId, chatId) {
  try {
    const response = await api().post("/parcel-monitoring/test-digest", { instanceId, chatId });
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function UploadParcelAlertEvidence(alertId, file) {
  try {
    const formData = new FormData();
    formData.append("photo", file);
    const response = await api().post(`/parcel-monitoring/alerts/${alertId}/evidence`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function DeleteParcelAlertEvidence(alertId, filename) {
  try {
    const response = await api().delete(`/parcel-monitoring/alerts/${alertId}/evidence/${filename}`);
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: "Network error" };
  }
}

export async function GetWhatsAppGroupChats(instanceId) {
  try {
    const response = await api().get(`/whatsapp/groups/${instanceId}/chats`);
    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: "Network error" };
  }
}
